import {shiftDate, shortDate, ymd} from '../../../src/utils/dates.ts';
import type {PrintEditionListing} from '../../../types/types.ts';
import {createElement} from '../../lib/dom.ts';
import {ContentSourceEdition} from '../../models/content-source-edition.ts';
import type {ReaderEdition} from '../../models/reader-edition.ts';

export function renderEndPage(endPageEl: HTMLElement, readerEdition: ReaderEdition) {
	endPageEl.innerHTML = '<h1>Ferdig.</h1>';

	if (readerEdition.productType === 'print') {
		const urlPrefix = 'reader';
		const recentEditionsEl = createElement(endPageEl.ownerDocument, 'div', 'recent-editions');
		const recentEditionsHeader = createElement(endPageEl.ownerDocument, 'div', 'recent-editions__header');
		recentEditionsHeader.innerHTML = `<h2>Seneste utgaver av<br/>${readerEdition.productTitle}:</h2>`;
		endPageEl.appendChild(recentEditionsHeader);
		readerEdition.latestEditions?.toReversed().forEach((editionListing: PrintEditionListing) => {
			const editionListingEl = createElement(endPageEl.ownerDocument, 'div', 'edition');
			editionListingEl.innerHTML = `<a href="/${urlPrefix}/${editionListing._id}">${shortDate(editionListing.publishDate, readerEdition.locale)}</a>`;
			if (editionListing._id === readerEdition.id) {
				editionListingEl.classList.add('edition--current');
			}
			recentEditionsEl.appendChild(editionListingEl);
		});

		endPageEl.appendChild(recentEditionsEl);
	}

	if (readerEdition instanceof ContentSourceEdition) {
		if (ymd(readerEdition.publishDate, readerEdition.timezone) !== ymd(new Date(), readerEdition.timezone)) {
			const dateLinkEl = createElement(endPageEl.ownerDocument, 'div', 'edition');
			dateLinkEl.innerHTML = `<a href="${readerEdition.getUrl(new Date())}">See today's articles</a>`;
			endPageEl.appendChild(dateLinkEl);
		}

		const recentEditionsEl = createElement(endPageEl.ownerDocument, 'div', 'recent-editions');
		const recentEditionsHeader = createElement(endPageEl.ownerDocument, 'div', 'recent-editions__header');
		recentEditionsHeader.innerHTML = `<h2>Tidligere publisert i<br/>${readerEdition.productTitle}:</h2>`;
		endPageEl.appendChild(recentEditionsHeader);

		const editionLinks = [];
		let offset = 0;
		while (offset > -14) {
			offset--;
			editionLinks.push(createRelativeDateLink(readerEdition.publishDate, offset));
		}
		recentEditionsEl.append(...editionLinks.filter((el) => el instanceof HTMLElement));
		endPageEl.appendChild(recentEditionsEl);
	}

	function createRelativeDateLink(startDate: string, days: number) {
		if (!(readerEdition instanceof ContentSourceEdition)) {
			return;
		}
		const date = shiftDate(new Date(startDate), days);
		const dateLinkEl = createElement(endPageEl.ownerDocument, 'div', 'edition');
		dateLinkEl.innerHTML = `<a href="${readerEdition.getUrl(date)}">${shortDate(date, readerEdition.locale)}</a>`;
		return dateLinkEl;
	}
}
